export enum PayformSortFields {
  EmployeeID = 'dsrEmployeeId',
  SIC = 'dmclSic',
  ReviewScore = 'reviewScore',
  ShiftStartDate = 'shiftStartDate',
  StatusCd = 'statusCd',
  EmployeeNames = 'employeeNames'
}
